import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, Router} from '@angular/router';
import {ContractService} from '../services/contract/contract.service';
import {BreadCrumbAndDataResolverService} from '../../utilities/services/route-resolvers/bread-crumb-and-data-resolver.service';
import {Contract} from '../interfaces/Contract';
import {BreadCrumbAndDataHelperService} from '../../utilities/services/route-resolvers/bread-crumb-and-data-helper.service';

@Injectable()
export class ContractNameResolverService extends BreadCrumbAndDataResolverService<Contract> {
  constructor(private contractService: ContractService, helper: BreadCrumbAndDataHelperService) {
    super(helper);
  }

  public async getData(route: ActivatedRouteSnapshot): Promise<Contract> {
    if (route.params.id)
      return await this.contractService.getContract(Number(route.params.id));
    else
      return await this.contractService.getDefaultContract();
  }
  public getName(data: Contract): string {
    return data.airport != null ? `${data.airport.name} Contract` : 'Default Contract';
  }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/contract/resolvers/contract-name-resolver.service.ts